import React, { useState } from 'react';
import './App.scss';
import { useMount } from '@/modules/hook';
import { ModuleContext } from '../module_context';

const data = ModuleContext.MacContext;

function App() {
  const [navid, setNavid] = useState(0);
  useMount(() => { });

  const onload = (e: any) => {
    console.log('🚀 ~ onload ~ e:', e);
    try {
      const title = e?.target?.contentDocument?.querySelector('.footerBar .content .title');
      const more = e?.target?.contentDocument?.querySelector('#main > div.expoler > div.morebefore');

      if (more) {
        more.style = 'visibility: hidden;';
      }
      if (title && title.innerText === '往期功能介绍') {
        title.style = 'visibility: hidden;';
      }
    } catch (error) {
      console.log('🚀 ~ onload ~ error:', error);
    }
  };

  return (
    <div className="App">
      <div className="sidebar">
        <div className="title-wrapper">
          <div className="title">QQ浏览器更新日志</div>
        </div>
        <ul className="navs-ul">
          {data.map((item, index) => (
            <li
              className={`navs-li ${index === navid ? 'sel' : ''}`}
              key={index}
              onClick={() => {
                setNavid(index);
              }}
            >
              {/* {index === navid ? (
                <div className="dot-wrapper">
                  <div className="dot"></div>
                </div>
              ) : null} */}
              <div className="content">
                <div className="vd">
                  <span className="v">{item.version}</span>
                  <span className="d">{item.date}</span>
                </div>
                <div className="desc">
                  <span>{item.desc}</span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {data[navid].link ? (
        <div className="iframeDiv">
          <iframe id="inlineFrameExample" key={data[navid].version} src={data[navid].link} onLoad={onload}></iframe>
        </div>
      ) : null}
      {data[navid]?.title && data?.[navid]?.content ? (
        <div className="connteDiv">
          <div className="header">
            <div className="title">QQ浏览器 {data[navid].version} for Windows 全新发布</div>
            <div className="desc">
              <span>发布日期： {data[navid].date.replace('（', '').replace('）', '')}</span>
              <span>发布版本： QQ浏览器 {data[navid].version} for Windows</span>
            </div>
          </div>
          <div className="point">
            <div className="title">{data[navid].title}</div>
            <div className="content">
              {data[navid].content?.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default App;
